// extracted by mini-css-extract-plugin
export default {"addReaction":"AddReaction_addReaction__x0ZE7","buttons":"AddReaction_buttons__Ed+uK"};